import { useEffect, useState } from "react";
import {
  Divider,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { Box, Card, CardContent, Typography } from "../../../../components";
import { MonitorFinanceiroService } from "../../../../services";
import { formatPrice, responseErros } from "../../../../utils";

const monitorFinanceiroService = new MonitorFinanceiroService();

const CORES_RANK = ["#f59e0b", "#94a3b8", "#b45309"];

function MonitorFinRankingInadimplencia({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    buscar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscar() {
    setLoading(true);
    const result =
      await monitorFinanceiroService.getDashboardRankingInadimplencia(
        filtrosBody,
      );
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  return (
    <Card sx={{ borderRadius: 3, border: "1px solid #f0f0f0", height: "100%" }}>
      <CardContent sx={{ p: 2 }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Ranking de Inadimplência · Maiores Devedores
          </Typography>
          <i
            className="ph-bold ph-thumbs-down"
            style={{ color: "#64748b", fontSize: 20 }}
          />
        </Box>
        <Divider sx={{ mb: 2 }} />
        {loading ? (
          <Box>
            {[1, 2, 3, 4, 5].map((i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                height={36}
                sx={{ mb: 1, borderRadius: 1 }}
              />
            ))}
          </Box>
        ) : rows.length === 0 ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={4}
            gap={1}
          >
            <i
              className="ph-bold ph-check-circle"
              style={{ fontSize: 32, color: "#388e3c" }}
            />
            <Typography variant="body2" color="text.secondary">
              Nenhum devedor em atraso.
            </Typography>
          </Box>
        ) : (
          <Table size="small">
            <TableHead sx={{ backgroundColor: "#f8fafc" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, width: 44 }} align="center">
                  #
                </TableCell>
                <TableCell sx={{ fontWeight: 700 }}>
                  Cliente / Devedor
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 700 }}>
                  Valor em Aberto
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 700 }}>
                  Dias em Atraso
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, i) => (
                <TableRow
                  key={row.pessoaId || i}
                  sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}
                >
                  <TableCell align="center">
                    <Box
                      sx={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        mx: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        fontWeight: 700,
                        color: i < 3 ? "#fff" : "#475569",
                        backgroundColor: i < 3 ? CORES_RANK[i] : "#e2e8f0",
                      }}
                    >
                      {i + 1}
                    </Box>
                  </TableCell>
                  <TableCell
                    sx={{
                      maxWidth: 220,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={row.nome}
                  >
                    {row.nome}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{ fontWeight: 700, color: "#1e293b" }}
                  >
                    {formatPrice(row.valorAberto)}
                  </TableCell>
                  <TableCell align="right" sx={{ color: "#d32f2f" }}>
                    {row.diasAtraso}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}

export default MonitorFinRankingInadimplencia;
